// extracted by mini-css-extract-plugin
export default {"tituloOutrosPosts":"Post_tituloOutrosPosts__cojkk","postsRecomendados":"Post_postsRecomendados__jdg74"};